(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('lcdb-yampi-buy-now')) return;

    // Shared lock also covers multiple product forms on the same page.
    let checkoutBusy = false;

    async function requestJSON(url, options = {}) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 25000);
      try {
        const response = await fetch(url, { ...options, signal: controller.signal });
        const payload = await response.json();
        if (!response.ok) {
          throw new Error(typeof payload.description === 'string'
            ? payload.description
            : 'Não foi possível concluir a solicitação.');
        }
        return payload;
      } finally {
        clearTimeout(timeout);
      }
    }

    class LcdbYampiBuyNow extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.button = this.querySelector('button');
        this.label = this.querySelector('[data-buy-label]');
        this.error = this.querySelector('[data-buy-error]');
        this.recovery = this.querySelector('[data-buy-recovery]');
        this.defaultLabel = this.label.textContent;
        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.buy();
        });
      }

      showError(message, showCart = false) {
        this.error.textContent = message;
        this.error.parentElement.hidden = false;
        this.recovery.hidden = !showCart;
      }

      async buy() {
        if (checkoutBusy || this.button.disabled) return;
        if (window.Shopify?.designMode) {
          this.showError('Abra a prévia da loja fora do editor para testar a compra.');
          return;
        }

        this.error.parentElement.hidden = true;
        const form = this.button.form || this.closest('form');
        if (!form) {
          this.showError('Não foi possível localizar o formulário deste produto.');
          return;
        }
        if (!form.reportValidity()) return;

        // Reads the CURRENT variant, quantity, properties and selling plan.
        const data = new FormData(form);
        if (!/^\d+$/.test(String(data.get('id') || ''))) {
          this.showError('Selecione uma opção disponível do produto.');
          return;
        }
        if (!data.has('quantity')) data.set('quantity', '1');
        if (!/^[1-9]\d*$/.test(String(data.get('quantity')))) {
          this.showError('Selecione uma quantidade válida.');
          return;
        }
        // No return_to redirect or section markup is needed in this flow.
        ['return_to', 'sections', 'sections_url', 'checkout'].forEach((key) => data.delete(key));

        checkoutBusy = true;
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.label.textContent = 'Preparando compra…';
        let addAttempted = false;
        let added = false;
        let navigating = false;
        const root = (this.dataset.cartRoot || '/').replace(/\/?$/, '/');

        try {
          addAttempted = true;
          const addition = requestJSON(root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            body: data
          });
          document.dispatchEvent(new CustomEvent('lcdb:cart-mutation', {
            detail: { promise: addition }
          }));
          await addition;
          added = true;
          this.label.textContent = 'Abrindo pagamento…';
          const cart = await requestJSON(root + 'cart.js', {
            credentials: 'same-origin', cache: 'no-store'
          });
          if (!Array.isArray(cart.items) || !cart.items.length) {
            throw new Error('O carrinho está vazio.');
          }

          // Exact public endpoint and payload used by the supplied YampiSnippet.
          const result = await requestJSON('https://api.dooki.com.br/v2/public/shopify/cart', {
            method: 'POST',
            credentials: 'omit',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              shop: window.location.host,
              shopify_internal_domain: this.dataset.shopDomain,
              cart_payload: cart
            })
          });
          if (!result.active || typeof result.checkout_direct_url !== 'string' || !result.checkout_direct_url.trim()) {
            throw new Error('O checkout Yampi não está disponível no momento.');
          }

          let target = new URL(result.checkout_direct_url);
          if (target.protocol !== 'https:' || target.username || target.password) {
            throw new Error('A integração retornou um endereço de checkout inválido.');
          }
          // Reuse the original integration's campaign attribution when available.
          if (typeof window.ymp_getUrlWithUtms === 'function') {
            try { target = new URL(window.ymp_getUrlWithUtms(target.href)); } catch (_) {}
          }
          if (target.protocol !== 'https:') throw new Error('Endereço de checkout inválido.');
          window.location.assign(target.href);
          navigating = true;
        } catch (error) {
          if (added) {
            this.showError('O produto foi adicionado, mas não foi possível abrir o pagamento. Continue pelo carrinho.', true);
          } else if (addAttempted) {
            const detail = error.name === 'AbortError' || error instanceof TypeError
              ? 'A conexão foi interrompida.'
              : error.message;
            this.showError(detail + ' Confira o carrinho antes de tentar novamente.', true);
          } else {
            this.showError(error.message);
          }
        } finally {
          if (!navigating) {
            checkoutBusy = false;
            this.button.removeAttribute('aria-busy');
            // Never repeat an uncertain cart mutation and accidentally duplicate items.
            this.button.disabled = addAttempted;
            this.label.textContent = addAttempted ? 'Continue pelo carrinho' : this.defaultLabel;
            if (addAttempted) this.recovery.focus();
          }
        }
      }
    }

    customElements.define('lcdb-yampi-buy-now', LcdbYampiBuyNow);
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      checkoutBusy = false;
      document.querySelectorAll('lcdb-yampi-buy-now').forEach((element) => {
        if (!element.button) return;
        element.button.disabled = false;
        element.button.removeAttribute('aria-busy');
        element.label.textContent = element.defaultLabel;
        element.error.parentElement.hidden = true;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
